module.exports = __webpack_public_path__ + "img/qr1.b21b005d.png";